import request from '@/utils/request';
import { datasetSubscribersEndpoint, datasetSubscriptionsEndpoint } from '@/constants/urls';

const subscribers = (code, event, filter, role, page, pageSize) => {
  const params = { filter, page, pageSize };

  if (role) {
    params.role = role;
  }

  return (
    request({
      url: datasetSubscribersEndpoint(code, event),
      params,
      method: 'GET',
    })
  );
};

const subscribe = (code, event) => (
  request({
    url: datasetSubscriptionsEndpoint(code, event),
    method: 'POST',
  })
);

const unsubscribe = (code, event) => (
  request({
    url: datasetSubscriptionsEndpoint(code, event),
    method: 'DELETE',
  })
);

const subscriptions = (code) => (
  request({
    url: datasetSubscriptionsEndpoint(code),
    method: 'GET',
  })
);

const DatasetSubscriptionsService = {
  subscribe,
  unsubscribe,
  subscriptions,
  subscribers,
};

export default DatasetSubscriptionsService;
